import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7b8ea2a9"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", {
    class: "title m-0"
  }, "We use cookies", -1);
});

var _hoisted_2 = /*#__PURE__*/_createTextVNode("OK");

import { usePermissionStore } from "@/store/permission";
export default /*#__PURE__*/_defineComponent({
  emits: ["consent"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var permissionStore = usePermissionStore();
    var appName = process.env.VUE_APP_NAME;

    var consent = function consent() {
      permissionStore.setCookies(true);
      emit("consent");
    };

    return function (_ctx, _cache) {
      var _component_n_button = _resolveComponent("n-button");

      var _component_n_alert = _resolveComponent("n-alert");

      return _openBlock(), _createBlock(_component_n_alert, {
        class: "c-alert rounded-0 py-4"
      }, {
        header: _withCtx(function () {
          return [_hoisted_1];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("p", null, _toDisplayString(_unref(appName)) + " use cookies and other tracking technologies to improve your browsing experience on our website, to analyze our website traffic, and to understand where our visitors are coming from. ", 1), _createVNode(_component_n_button, {
            type: "primary",
            disabled: _unref(permissionStore).cookies,
            onClick: consent
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }, 8, ["disabled"])];
        }),
        _: 1
      });
    };
  }
});